import { forwardRef, useCallback, useContext } from "react";
import classNames from "classnames";
import { useSegment } from "./context";
import SegmentContext from "./context";
import PropTypes from "prop-types";

const unwrapArray = (arg) => (Array.isArray(arg) ? arg[0] : arg);

const SegmentItem = forwardRef((props, ref) => {
  const { size } = useContext(SegmentContext);

  const {
    value: valueProp,
    children,
    className,
    disabled,
    incrementDisabled,
    ...rest
  } = props;

  const {
    value: valueContext,
    onActive,
    onDeactivate,
    selectionType,
  } = useSegment();

  const isQuantity = selectionType === "quantity";
  const entry = isQuantity
    ? valueContext.find((v) => v && v.id === valueProp)
    : null;
  const active = isQuantity ? !!entry : valueContext.includes(valueProp);
  const qty = entry ? entry.qty ?? 1 : 0;

  const onSegmentItemClick = () => {
    if (disabled) return;

    if (isQuantity) {
      if (!active) {
        onActive([...valueContext, { id: valueProp, qty: 1 }]);
      } else if (!incrementDisabled) {
        onActive(
          valueContext.map((v) =>
            v.id === valueProp ? { ...v, qty: (v.qty ?? 1) + 1 } : v
          )
        );
      }
      return;
    }

    if (!active) {
      if (selectionType === "single") {
        onActive([valueProp]);
      }
      if (selectionType === "multiple") {
        const nextValue = [...valueContext, ...[valueProp]];
        onActive(nextValue);
      }
    } else {
      onDeactivate(valueProp);
    }
  };

  const onSegmentItemDecrement = () => {
    if (!isQuantity || !active) return;
    if ((entry.qty ?? 1) <= 1) {
      onDeactivate(valueProp);
      return;
    }
    onActive(
      valueContext.map((v) =>
        v.id === valueProp ? { ...v, qty: (v.qty ?? 1) - 1 } : v
      )
    );
  };

  const childrenProps = {
    ref: ref,
    active,
    qty,
    onSegmentItemClick,
    onSegmentItemDecrement,
    disabled,
    value: valueProp,
    ...rest,
  };

  return typeof children === "function" ? (
    unwrapArray(children)(childrenProps)
  ) : (
    <button
      className={classNames(
        "segment-item segment-item-default",
        active && "segment-item-active",
        disabled && "segment-item-disabled",
        className
      )}
      onClick={onSegmentItemClick}
      {...rest}
    >
      {children}
    </button>
  );
});

SegmentItem.defaultProps = {
  disabled: false,
};

SegmentItem.propTypes = {
  value: PropTypes.string,
  disabled: PropTypes.bool,
  incrementDisabled: PropTypes.bool,
};

export default SegmentItem;
